import { BehaviourItem } from '../../../coaching-tags/models/behaviour.coaching.model';
import { SubBehaviourItem } from '../../../coaching-tags/models/subbehaviour.coaching.model';
import { BlDocument, BlFocus } from '../core';

import { Focus } from './model/focus.model';

export interface BlDialogState {
    pending: {
        documents?: boolean;
    };
    behaviours?: BehaviourItem[];
    subBehaviours?: SubBehaviourItem[];
    focuses?: BlFocus[];
    documents?: BlDocument[];
    focus?: Focus;
}

export const defaultState = (): BlDialogState => ({
    pending: {},
});
